import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { apolloClient } from '~/common/apollo-client'
import { useAuth } from '~/common/hooks/useAuth'

/**
 * Returns a handler that fully signs the user out: clears WorkOS session state,
 * drops all cached Apollo data so the next user can't see stale results, and
 * lands on the login page.
 */
export const useSignOutHandler = (): (() => Promise<void>) => {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  return useCallback(async () => {
    signOut()
    await apolloClient.clearStore()
    await navigate('/auth/login', { replace: true })
  }, [signOut, navigate])
}
